import { ClientList } from "../domain/clients";
import { getClientsByIdCompanyService } from "../infrastructure/services/getClientsByIdCompanyService";


export const getClientsByIdCompany = {
  async execute(): Promise<ClientList[]> {
    return await getClientsByIdCompanyService.execute();
  },
};
